import React from 'react';
import {
    Grid,
    TextField,
    MenuItem,
    Select,
    InputLabel,
    FormControl
} from '@mui/material';
import { useLanguage } from '../../Commun/contexts/LanguageContext';
import { ComponentItem } from '../components/ComponentLibrary';

interface ComponentFormProps {
    formData: Partial<ComponentItem>;
    onChange: (data: Partial<ComponentItem>) => void;
}

const ComponentForm: React.FC<ComponentFormProps> = ({ formData, onChange }) => {
    const { t } = useLanguage();

    const handleChange = (field: keyof ComponentItem, value: any) => {
        onChange({ ...formData, [field]: value });
    };

    return (
        <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
                <TextField
                    label={t('maker.field.name')}
                    fullWidth
                    value={formData.name || ''}
                    onChange={(e) => handleChange('name', e.target.value)}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label={t('maker.field.description')}
                    fullWidth
                    value={formData.description || ''}
                    onChange={(e) => handleChange('description', e.target.value)}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label={'Icon (Emoji)'}
                    fullWidth
                    value={formData.icon || '🔧'}
                    onChange={(e) => handleChange('icon', e.target.value)}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label={t('maker.field.unitPrice')}
                    type="number"
                    fullWidth
                    value={formData.unitPrice || 0}
                    onChange={(e) => handleChange('unitPrice', parseFloat(e.target.value))}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label="Quantity"
                    type="number"
                    fullWidth
                    value={formData.defaultQuantity || 1}
                    onChange={(e) => handleChange('defaultQuantity', parseInt(e.target.value))}
                />
            </Grid>
            <Grid item xs={12}>
                <FormControl fullWidth>
                    <InputLabel>Type</InputLabel>
                    <Select
                        value={formData.category || 'hardware'}
                        label="Type"
                        onChange={(e) => handleChange('category', e.target.value)}
                    >
                        <MenuItem value="hardware">{t('maker.design.components.cat.hardware')}</MenuItem>
                        <MenuItem value="shutter">{t('maker.design.components.cat.shutter')}</MenuItem>
                        <MenuItem value="screen">{t('maker.design.components.cat.screen')}</MenuItem>
                        <MenuItem value="roller">{t('maker.design.components.cat.roller')}</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default ComponentForm;
